import { PropsWithChildren } from 'react';
import ReactMarkdown from 'react-markdown';

import { ButtonProps } from '../02-atoms/Button';
import { Media, MediaProps } from '../02-atoms/Media';
import { hasMedia } from '../02-atoms/Media.utils';
import { ButtonGroup } from '../03-molecules/ButtonGroup';

export interface CTAProps extends PropsWithChildren {
  /** The title */
  title: string | JSX.Element;
  /** Content */
  content?: string;
  /** Markdown */
  markdown?: boolean;
  /** Image */
  image?: MediaProps;
  /** List of buttons */
  actions?: ButtonProps[];
}

/** Block rendering a Call to Action */
export const CTA = ({
  title,
  content,
  markdown,
  image,
  actions,
  children,
  ...props
}: CTAProps) => {
  return (
    <div className="cta" {...props}>
      <div className="cta__wrapper">
        {hasMedia(image) && <Media className="cta__image" {...image} />}
        <div className="cta__content">
          <h3 className="cta__title">{title}</h3>
          <div className="cta__details">
            {content && (
              <>
                {markdown ? (
                  <ReactMarkdown>{content as string}</ReactMarkdown>
                ) : (
                  content
                )}
              </>
            )}
            {children}
            {actions && (
              <ButtonGroup className="cta__actions" items={actions} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
